import { Box, alpha } from '@mui/material';

export const GroupMessageSmsPreviewChatBubble = () => {
  // HTML AND CSS FROM; https://codepen.io/bilalck/pen/jdGGNW
  return (
    <Box
      sx={{
        backgroundColor: (thm) => thm.palette.grey[300],
        p: 2,
        borderRadius: 3,
        borderBottomLeftRadius: 0,
        display: 'inline-block',
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          height: '17px',
          '& .dot': {
            animation: 'mercuryTypingAnimation 1.8s infinite ease-in-out',
            backgroundColor: (thm) => thm.palette.grey[800],
            borderRadius: '50%',
            height: '10px',
            marginRight: '4px',
            verticalAlign: 'middle',
            width: '10px',
            display: 'inline-block',
            '&:nth-of-type(1)': { animationDelay: '200ms' },
            '&:nth-of-type(2)': { animationDelay: '300ms' },
            '&:nth-of-type(3)': { animationDelay: '400ms' },
            '&:last-child ': { marginRight: 0 },
          },
          '@keyframes mercuryTypingAnimation': {
            '0%': {
              transform: 'translateY(0px)',
              backgroundColor: (thm) => alpha(thm.palette.grey[800], 0.7),
            },
            '28%': {
              transform: 'translateY(-10px)',
              backgroundColor: (thm) => alpha(thm.palette.grey[800], 0.4),
            },
            '44%': {
              transform: 'translateY(0px)',
              backgroundColor: (thm) => alpha(thm.palette.grey[800], 0.2),
            },
          },
        }}
      >
        <Box className='dot' />
        <Box className='dot' />
        <Box className='dot' />
      </Box>
    </Box>
  );
};
